/*
 * Copyright 2023 StarTree Inc.
 *
 * All rights reserved. Confidential and proprietary information of StarTree Inc.
 */
const PLACEHOLDER_ORGANIZATION_ID = ":organizationId";
const PLACEHOLDER_ENVIRONMENT_ID = ":environmentId";
const PLACEHOLDER_PINOT_CLUSTER_NAME = ":pinotClusterName";
const PLACEHOLDER_CLOUD_PROVIDER_ID = ":cloudProviderId";
const PLACEHOLDER_IDENTITY_PROVIDER_ID = ":identityProviderId";

export const AppRoute = {
    BASE: "/",
    HOME: "/home",
    NEW_USER: "/new-user",

    ORGANIZATIONS: "/organizations",
    ORGANIZATIONS_LIST: "/organizations/list",
    ORGANIZATIONS_VIEW: `/organizations/${PLACEHOLDER_ORGANIZATION_ID}/view`,
    ORGANIZATIONS_VIEW_ENVIRONMENTS: `/organizations/${PLACEHOLDER_ORGANIZATION_ID}/view/environments`,
    ORGANIZATIONS_VIEW_CLOUD_PROVIDERS: `/organizations/${PLACEHOLDER_ORGANIZATION_ID}/view/cloud-providers`,
    ORGANIZATIONS_VIEW_IDENTITY_PROVIDERS: `/organizations/${PLACEHOLDER_ORGANIZATION_ID}/view/identity-providers`,
    ORGANIZATIONS_VIEW_USERS: `/organizations/${PLACEHOLDER_ORGANIZATION_ID}/view/users`,
    ORGANIZATIONS_VIEW_ADVANCED: `/organizations/${PLACEHOLDER_ORGANIZATION_ID}/view/advanced`,
    ORGANIZATIONS_CREATE: "/organizations/create",

    ENVIRONMENTS: `/organizations/${PLACEHOLDER_ORGANIZATION_ID}/view/environments`,
    ENVIRONMENTS_LIST: `/organizations/${PLACEHOLDER_ORGANIZATION_ID}/view/environments/list`,
    ENVIRONMENTS_VIEW: `/organizations/${PLACEHOLDER_ORGANIZATION_ID}/view/environments/${PLACEHOLDER_ENVIRONMENT_ID}/view`,
    ENVIRONMENTS_VIEW_GENERAL: `/organizations/${PLACEHOLDER_ORGANIZATION_ID}/view/environments/${PLACEHOLDER_ENVIRONMENT_ID}/view/general`,
    ENVIRONMENTS_VIEW_SERVICES: `/organizations/${PLACEHOLDER_ORGANIZATION_ID}/view/environments/${PLACEHOLDER_ENVIRONMENT_ID}/view/services`,
    ENVIRONMENTS_VIEW_PINOT_CLUSTERS: `/organizations/${PLACEHOLDER_ORGANIZATION_ID}/view/environments/${PLACEHOLDER_ENVIRONMENT_ID}/view/pinot-clusters`,
    ENVIRONMENTS_VIEW_OPERATIONS: `/organizations/${PLACEHOLDER_ORGANIZATION_ID}/view/environments/${PLACEHOLDER_ENVIRONMENT_ID}/view/operations`,
    ENVIRONMENTS_VIEW_ADVANCED: `/organizations/${PLACEHOLDER_ORGANIZATION_ID}/view/environments/${PLACEHOLDER_ENVIRONMENT_ID}/view/advanced`,
    ENVIRONMENTS_CREATE_BYOC: `/organizations/${PLACEHOLDER_ORGANIZATION_ID}/view/environments/create/byoc`,
    ENVIRONMENTS_CREATE_SAAS: `/organizations/${PLACEHOLDER_ORGANIZATION_ID}/view/environments/create/saas`,
    ENVIRONMENTS_EDIT_GENERAL: `/organizations/${PLACEHOLDER_ORGANIZATION_ID}/view/environments/${PLACEHOLDER_ENVIRONMENT_ID}/edit/general`,
    ENVIRONMENTS_EDIT_NETWORK_CONFIGURATION: `/organizations/${PLACEHOLDER_ORGANIZATION_ID}/view/environments/${PLACEHOLDER_ENVIRONMENT_ID}/edit/network-configuration`,

    PINOT_CLUSTERS: `/organizations/${PLACEHOLDER_ORGANIZATION_ID}/view/environments/${PLACEHOLDER_ENVIRONMENT_ID}/view/pinot-clusters`,
    PINOT_CLUSTERS_LIST: `/organizations/${PLACEHOLDER_ORGANIZATION_ID}/view/environments/${PLACEHOLDER_ENVIRONMENT_ID}/view/pinot-clusters/list`,
    PINOT_CLUSTERS_VIEW: `/organizations/${PLACEHOLDER_ORGANIZATION_ID}/view/environments/${PLACEHOLDER_ENVIRONMENT_ID}/view/pinot-clusters/${PLACEHOLDER_PINOT_CLUSTER_NAME}/view`,
    PINOT_CLUSTERS_VIEW_GENERAL: `/organizations/${PLACEHOLDER_ORGANIZATION_ID}/view/environments/${PLACEHOLDER_ENVIRONMENT_ID}/view/pinot-clusters/${PLACEHOLDER_PINOT_CLUSTER_NAME}/view/general`,
    PINOT_CLUSTERS_VIEW_AUDIT_LOGS:
        `/organizations/${PLACEHOLDER_ORGANIZATION_ID}/view/environments/${PLACEHOLDER_ENVIRONMENT_ID}/view/pinot-clusters/${PLACEHOLDER_PINOT_CLUSTER_NAME}/view/` +
        `audit-logs`,
    PINOT_CLUSTERS_VIEW_API_TOKENS:
        `/organizations/${PLACEHOLDER_ORGANIZATION_ID}/view/environments/${PLACEHOLDER_ENVIRONMENT_ID}/view/pinot-clusters/${PLACEHOLDER_PINOT_CLUSTER_NAME}/view/` +
        `api-tokens`,
    PINOT_CLUSTERS_VIEW_ADVANCED: `/organizations/${PLACEHOLDER_ORGANIZATION_ID}/view/environments/${PLACEHOLDER_ENVIRONMENT_ID}/view/pinot-clusters/${PLACEHOLDER_PINOT_CLUSTER_NAME}/view/advanced`,
    PINOT_CLUSTERS_CREATE: `/organizations/${PLACEHOLDER_ORGANIZATION_ID}/view/environments/${PLACEHOLDER_ENVIRONMENT_ID}/view/pinot-clusters/create`,
    PINOT_CLUSTERS_EDIT: `/organizations/${PLACEHOLDER_ORGANIZATION_ID}/view/environments/${PLACEHOLDER_ENVIRONMENT_ID}/view/pinot-clusters/${PLACEHOLDER_PINOT_CLUSTER_NAME}/edit`,

    CLOUD_PROVIDERS: `/organizations/${PLACEHOLDER_ORGANIZATION_ID}/view/cloud-providers`,
    CLOUD_PROVIDERS_LIST: `/organizations/${PLACEHOLDER_ORGANIZATION_ID}/view/cloud-providers/list`,
    CLOUD_PROVIDERS_VIEW: `/organizations/${PLACEHOLDER_ORGANIZATION_ID}/view/cloud-providers/${PLACEHOLDER_CLOUD_PROVIDER_ID}/view`,
    CLOUD_PROVIDERS_VIEW_GENERAL: `/organizations/${PLACEHOLDER_ORGANIZATION_ID}/view/cloud-providers/${PLACEHOLDER_CLOUD_PROVIDER_ID}/view/general`,
    CLOUD_PROVIDERS_VIEW_ADVANCED: `/organizations/${PLACEHOLDER_ORGANIZATION_ID}/view/cloud-providers/${PLACEHOLDER_CLOUD_PROVIDER_ID}/view/advanced`,
    CLOUD_PROVIDERS_CREATE: `/organizations/${PLACEHOLDER_ORGANIZATION_ID}/view/cloud-providers/create`,
    CLOUD_PROVIDERS_EDIT: `/organizations/${PLACEHOLDER_ORGANIZATION_ID}/view/cloud-providers/${PLACEHOLDER_CLOUD_PROVIDER_ID}/edit`,

    IDENTITY_PROVIDERS: `/organizations/${PLACEHOLDER_ORGANIZATION_ID}/view/identity-providers`,
    IDENTITY_PROVIDERS_LIST: `/organizations/${PLACEHOLDER_ORGANIZATION_ID}/view/identity-providers/list`,
    IDENTITY_PROVIDERS_VIEW: `/organizations/${PLACEHOLDER_ORGANIZATION_ID}/view/identity-providers/${PLACEHOLDER_IDENTITY_PROVIDER_ID}/view`,
    IDENTITY_PROVIDERS_VIEW_GENERAL: `/organizations/${PLACEHOLDER_ORGANIZATION_ID}/view/identity-providers/${PLACEHOLDER_IDENTITY_PROVIDER_ID}/view/general`,
    IDENTITY_PROVIDERS_VIEW_ADVANCED: `/organizations/${PLACEHOLDER_ORGANIZATION_ID}/view/identity-providers/${PLACEHOLDER_IDENTITY_PROVIDER_ID}/view/advanced`,
    IDENTITY_PROVIDERS_CREATE: `/organizations/${PLACEHOLDER_ORGANIZATION_ID}/view/identity-providers/create`,

    USERS: `/organizations/${PLACEHOLDER_ORGANIZATION_ID}/view/users`,
    USERS_LIST: `/organizations/${PLACEHOLDER_ORGANIZATION_ID}/view/users/list`,
    USERS_INVITE: `/organizations/${PLACEHOLDER_ORGANIZATION_ID}/view/users/invite`,

    LOGIN: "/login",
    SIGNUP: "/signup",
    THANK_YOU_FOR_SIGNING_UP: "/thank-you",
    LOGOUT: "/logout",
} as const;

export const CloudV2ForbiddenRoutes = [
    AppRoute.HOME,

    // organization
    AppRoute.ORGANIZATIONS,
    AppRoute.ORGANIZATIONS_LIST,
    AppRoute.ORGANIZATIONS_VIEW,
    AppRoute.ORGANIZATIONS_VIEW_ENVIRONMENTS,
    AppRoute.ORGANIZATIONS_VIEW_CLOUD_PROVIDERS,
    AppRoute.ORGANIZATIONS_VIEW_IDENTITY_PROVIDERS,
    AppRoute.ORGANIZATIONS_VIEW_USERS,
    AppRoute.ORGANIZATIONS_VIEW_ADVANCED,
    AppRoute.ORGANIZATIONS_CREATE,

    // environment
    AppRoute.ENVIRONMENTS,
    AppRoute.ENVIRONMENTS_LIST,
    AppRoute.ENVIRONMENTS_VIEW,
    AppRoute.ENVIRONMENTS_VIEW_GENERAL,
    AppRoute.ENVIRONMENTS_VIEW_SERVICES,
    AppRoute.ENVIRONMENTS_VIEW_PINOT_CLUSTERS,
    AppRoute.ENVIRONMENTS_VIEW_OPERATIONS,
    AppRoute.ENVIRONMENTS_VIEW_ADVANCED,
    AppRoute.ENVIRONMENTS_CREATE_BYOC,
    AppRoute.ENVIRONMENTS_CREATE_SAAS,
    AppRoute.ENVIRONMENTS_EDIT_GENERAL,
    AppRoute.ENVIRONMENTS_EDIT_NETWORK_CONFIGURATION,

    // cluster
    AppRoute.PINOT_CLUSTERS,
    AppRoute.PINOT_CLUSTERS_LIST,
    AppRoute.PINOT_CLUSTERS_VIEW,
    AppRoute.PINOT_CLUSTERS_VIEW_GENERAL,
    AppRoute.PINOT_CLUSTERS_VIEW_AUDIT_LOGS,
    AppRoute.PINOT_CLUSTERS_VIEW_API_TOKENS,
    AppRoute.PINOT_CLUSTERS_VIEW_ADVANCED,
    AppRoute.PINOT_CLUSTERS_CREATE,
    AppRoute.PINOT_CLUSTERS_EDIT,

    // cloud providers
    AppRoute.CLOUD_PROVIDERS,
    AppRoute.CLOUD_PROVIDERS_LIST,
    AppRoute.CLOUD_PROVIDERS_VIEW,
    AppRoute.CLOUD_PROVIDERS_VIEW_GENERAL,
    AppRoute.CLOUD_PROVIDERS_VIEW_ADVANCED,
    AppRoute.CLOUD_PROVIDERS_CREATE,
    AppRoute.CLOUD_PROVIDERS_EDIT,

    // identity providers
    AppRoute.IDENTITY_PROVIDERS,
    AppRoute.IDENTITY_PROVIDERS_LIST,
    AppRoute.IDENTITY_PROVIDERS_VIEW,
    AppRoute.IDENTITY_PROVIDERS_VIEW_GENERAL,
    AppRoute.IDENTITY_PROVIDERS_VIEW_ADVANCED,
    AppRoute.IDENTITY_PROVIDERS_CREATE,

    // user
    AppRoute.USERS,
    AppRoute.USERS_LIST,
    AppRoute.USERS_INVITE,
];

export const SaasForbiddenRoutes = [
    // Environment
    AppRoute.ENVIRONMENTS_EDIT_GENERAL,
    AppRoute.ENVIRONMENTS_EDIT_NETWORK_CONFIGURATION,
    AppRoute.ENVIRONMENTS_VIEW_OPERATIONS,
    AppRoute.ENVIRONMENTS_CREATE_BYOC,

    // Pinot cluster
    AppRoute.PINOT_CLUSTERS_VIEW_AUDIT_LOGS,
    AppRoute.PINOT_CLUSTERS_VIEW_ADVANCED,
    AppRoute.PINOT_CLUSTERS_CREATE,
    AppRoute.PINOT_CLUSTERS_EDIT,

    // cloud provider
    AppRoute.CLOUD_PROVIDERS_LIST,
    AppRoute.CLOUD_PROVIDERS_VIEW,
    AppRoute.CLOUD_PROVIDERS_VIEW_GENERAL,
    AppRoute.CLOUD_PROVIDERS_VIEW_ADVANCED,
    AppRoute.CLOUD_PROVIDERS_CREATE,
    AppRoute.CLOUD_PROVIDERS_EDIT,

    // identity provider
    AppRoute.IDENTITY_PROVIDERS_LIST,
    AppRoute.IDENTITY_PROVIDERS_VIEW,
    AppRoute.IDENTITY_PROVIDERS_VIEW_GENERAL,
    AppRoute.IDENTITY_PROVIDERS_VIEW_ADVANCED,
    AppRoute.IDENTITY_PROVIDERS_CREATE,
];

export const ByocForbiddenRoutes = [
    // Environment
    AppRoute.ENVIRONMENTS_CREATE_SAAS,
    AppRoute.ENVIRONMENTS_VIEW_ADVANCED,
    AppRoute.ENVIRONMENTS_CREATE_BYOC,
    AppRoute.ENVIRONMENTS_EDIT_GENERAL,
    AppRoute.ENVIRONMENTS_EDIT_NETWORK_CONFIGURATION,

    // Pinot cluster
    AppRoute.PINOT_CLUSTERS_VIEW_ADVANCED,
    AppRoute.PINOT_CLUSTERS_CREATE,
    AppRoute.PINOT_CLUSTERS_EDIT,

    // cloud provider
    AppRoute.CLOUD_PROVIDERS_VIEW_ADVANCED,
    AppRoute.CLOUD_PROVIDERS_CREATE,
    AppRoute.CLOUD_PROVIDERS_EDIT,

    // identity provider
    AppRoute.IDENTITY_PROVIDERS_VIEW_ADVANCED,
    AppRoute.IDENTITY_PROVIDERS_CREATE,
];

export const getBasePath = (): string => {
    return AppRoute.BASE;
};

export const getHomePath = (): string => {
    return AppRoute.HOME;
};

export const getNewUserPath = (): string => {
    return AppRoute.NEW_USER;
};

export const getOrganizationsPath = (): string => {
    return AppRoute.ORGANIZATIONS;
};

export const getOrganizationsListPath = (): string => {
    return AppRoute.ORGANIZATIONS_LIST;
};

export const getOrganizationsViewPath = (organizationId: string): string => {
    return `${AppRoute.ORGANIZATIONS_VIEW.replace(
        PLACEHOLDER_ORGANIZATION_ID,
        organizationId
    )}`;
};

export const getOrganizationsViewEnvironmentsPath = (
    organizationId: string
): string => {
    return `${AppRoute.ORGANIZATIONS_VIEW_ENVIRONMENTS.replace(
        PLACEHOLDER_ORGANIZATION_ID,
        organizationId
    )}`;
};

export const getOrganizationsViewCloudProvidersPath = (
    organizationId: string
): string => {
    return `${AppRoute.ORGANIZATIONS_VIEW_CLOUD_PROVIDERS.replace(
        PLACEHOLDER_ORGANIZATION_ID,
        organizationId
    )}`;
};

export const getOrganizationsViewIdentityProvidersPath = (
    organizationId: string
): string => {
    return `${AppRoute.ORGANIZATIONS_VIEW_IDENTITY_PROVIDERS.replace(
        PLACEHOLDER_ORGANIZATION_ID,
        organizationId
    )}`;
};

export const getOrganizationsViewUsersPath = (
    organizationId: string
): string => {
    return `${AppRoute.ORGANIZATIONS_VIEW_USERS.replace(
        PLACEHOLDER_ORGANIZATION_ID,
        organizationId
    )}`;
};

export const getOrganizationsViewAdvancedPath = (
    organizationId: string
): string => {
    return `${AppRoute.ORGANIZATIONS_VIEW_ADVANCED.replace(
        PLACEHOLDER_ORGANIZATION_ID,
        organizationId
    )}`;
};

export const getOrganizationsCreatePath = (): string => {
    return AppRoute.ORGANIZATIONS_CREATE;
};

export const getEnvironmentsPath = (organizationId: string): string => {
    return `${AppRoute.ENVIRONMENTS.replace(
        PLACEHOLDER_ORGANIZATION_ID,
        organizationId
    )}`;
};

export const getEnvironmentsListPath = (organizationId: string): string => {
    return `${AppRoute.ENVIRONMENTS_LIST.replace(
        PLACEHOLDER_ORGANIZATION_ID,
        organizationId
    )}`;
};

export const getEnvironmentsViewPath = (
    organizationId: string,
    environmentId: string
): string => {
    return `${AppRoute.ENVIRONMENTS_VIEW.replace(
        PLACEHOLDER_ORGANIZATION_ID,
        organizationId
    ).replace(PLACEHOLDER_ENVIRONMENT_ID, environmentId)}`;
};

export const getEnvironmentsViewGeneralPath = (
    organizationId: string,
    environmentId: string
): string => {
    return `${AppRoute.ENVIRONMENTS_VIEW_GENERAL.replace(
        PLACEHOLDER_ORGANIZATION_ID,
        organizationId
    ).replace(PLACEHOLDER_ENVIRONMENT_ID, environmentId)}`;
};

export const getEnvironmentsViewServicesPath = (
    organizationId: string,
    environmentId: string
): string => {
    return `${AppRoute.ENVIRONMENTS_VIEW_SERVICES.replace(
        PLACEHOLDER_ORGANIZATION_ID,
        organizationId
    ).replace(PLACEHOLDER_ENVIRONMENT_ID, environmentId)}`;
};

export const getEnvironmentsViewPinotClustersPath = (
    organizationId: string,
    environmentId: string
): string => {
    return `${AppRoute.ENVIRONMENTS_VIEW_PINOT_CLUSTERS.replace(
        PLACEHOLDER_ORGANIZATION_ID,
        organizationId
    ).replace(PLACEHOLDER_ENVIRONMENT_ID, environmentId)}`;
};

export const getEnvironmentsViewOperationsPath = (
    organizationId: string,
    environmentId: string
): string => {
    return `${AppRoute.ENVIRONMENTS_VIEW_OPERATIONS.replace(
        PLACEHOLDER_ORGANIZATION_ID,
        organizationId
    ).replace(PLACEHOLDER_ENVIRONMENT_ID, environmentId)}`;
};

export const getEnvironmentsViewAdvancedPath = (
    organizationId: string,
    environmentId: string
): string => {
    return `${AppRoute.ENVIRONMENTS_VIEW_ADVANCED.replace(
        PLACEHOLDER_ORGANIZATION_ID,
        organizationId
    ).replace(PLACEHOLDER_ENVIRONMENT_ID, environmentId)}`;
};

export const getEnvironmentsCreatePath = (organizationId: string): string => {
    return `${AppRoute.ENVIRONMENTS_CREATE_BYOC.replace(
        PLACEHOLDER_ORGANIZATION_ID,
        organizationId
    )}`;
};

export const getEnvironmentsSaasCreatePath = (
    organizationId: string
): string => {
    return `${AppRoute.ENVIRONMENTS_CREATE_SAAS.replace(
        PLACEHOLDER_ORGANIZATION_ID,
        organizationId
    )}`;
};

export const getEnvironmentsEditGeneralPath = (
    organizationId: string,
    environmentId: string
): string => {
    return `${AppRoute.ENVIRONMENTS_EDIT_GENERAL.replace(
        PLACEHOLDER_ORGANIZATION_ID,
        organizationId
    ).replace(PLACEHOLDER_ENVIRONMENT_ID, environmentId)}`;
};

export const getEnvironmentsEditNetworkConfigurationPath = (
    organizationId: string,
    environmentId: string
): string => {
    return `${AppRoute.ENVIRONMENTS_EDIT_NETWORK_CONFIGURATION.replace(
        PLACEHOLDER_ORGANIZATION_ID,
        organizationId
    ).replace(PLACEHOLDER_ENVIRONMENT_ID, environmentId)}`;
};

export const getPinotClustersPath = (
    organizationId: string,
    environmentId: string
): string => {
    return `${AppRoute.PINOT_CLUSTERS.replace(
        PLACEHOLDER_ORGANIZATION_ID,
        organizationId
    ).replace(PLACEHOLDER_ENVIRONMENT_ID, environmentId)}`;
};

export const getPinotClustersListPath = (
    organizationId: string,
    environmentId: string
): string => {
    return `${AppRoute.PINOT_CLUSTERS_LIST.replace(
        PLACEHOLDER_ORGANIZATION_ID,
        organizationId
    ).replace(PLACEHOLDER_ENVIRONMENT_ID, environmentId)}`;
};

export const getPinotClustersViewPath = (
    organizationId: string,
    environmentId: string,
    pinotClusterName: string
): string => {
    return `${AppRoute.PINOT_CLUSTERS_VIEW.replace(
        PLACEHOLDER_ORGANIZATION_ID,
        organizationId
    )
        .replace(PLACEHOLDER_ENVIRONMENT_ID, environmentId)
        .replace(PLACEHOLDER_PINOT_CLUSTER_NAME, pinotClusterName)}`;
};

export const getPinotClustersViewGeneralPath = (
    organizationId: string,
    environmentId: string,
    pinotClusterName: string
): string => {
    return `${AppRoute.PINOT_CLUSTERS_VIEW_GENERAL.replace(
        PLACEHOLDER_ORGANIZATION_ID,
        organizationId
    )
        .replace(PLACEHOLDER_ENVIRONMENT_ID, environmentId)
        .replace(PLACEHOLDER_PINOT_CLUSTER_NAME, pinotClusterName)}`;
};

export const getPinotClustersViewAuditLogsPath = (
    organizationId: string,
    environmentId: string,
    pinotClusterName: string
): string => {
    return `${AppRoute.PINOT_CLUSTERS_VIEW_AUDIT_LOGS.replace(
        PLACEHOLDER_ORGANIZATION_ID,
        organizationId
    )
        .replace(PLACEHOLDER_ENVIRONMENT_ID, environmentId)
        .replace(PLACEHOLDER_PINOT_CLUSTER_NAME, pinotClusterName)}`;
};

export const getPinotClustersViewApiTokensPath = (
    organizationId: string,
    environmentId: string,
    pinotClusterName: string
): string => {
    return `${AppRoute.PINOT_CLUSTERS_VIEW_API_TOKENS.replace(
        PLACEHOLDER_ORGANIZATION_ID,
        organizationId
    )
        .replace(PLACEHOLDER_ENVIRONMENT_ID, environmentId)
        .replace(PLACEHOLDER_PINOT_CLUSTER_NAME, pinotClusterName)}`;
};

export const getPinotClustersViewAdvancedPath = (
    organizationId: string,
    environmentId: string,
    pinotClusterName: string
): string => {
    return `${AppRoute.PINOT_CLUSTERS_VIEW_ADVANCED.replace(
        PLACEHOLDER_ORGANIZATION_ID,
        organizationId
    )
        .replace(PLACEHOLDER_ENVIRONMENT_ID, environmentId)
        .replace(PLACEHOLDER_PINOT_CLUSTER_NAME, pinotClusterName)}`;
};

export const getPinotClustersCreatePath = (
    organizationId: string,
    environmentId: string
): string => {
    return `${AppRoute.PINOT_CLUSTERS_CREATE.replace(
        PLACEHOLDER_ORGANIZATION_ID,
        organizationId
    ).replace(PLACEHOLDER_ENVIRONMENT_ID, environmentId)}`;
};

export const getPinotClustersEditPath = (
    organizationId: string,
    environmentId: string,
    pinotClusterName: string
): string => {
    return `${AppRoute.PINOT_CLUSTERS_EDIT.replace(
        PLACEHOLDER_ORGANIZATION_ID,
        organizationId
    )
        .replace(PLACEHOLDER_ENVIRONMENT_ID, environmentId)
        .replace(PLACEHOLDER_PINOT_CLUSTER_NAME, pinotClusterName)}`;
};

export const getCloudProvidersPath = (organizationId: string): string => {
    return `${AppRoute.CLOUD_PROVIDERS.replace(
        PLACEHOLDER_ORGANIZATION_ID,
        organizationId
    )}`;
};

export const getCloudProvidersListPath = (organizationId: string): string => {
    return `${AppRoute.CLOUD_PROVIDERS_LIST.replace(
        PLACEHOLDER_ORGANIZATION_ID,
        organizationId
    )}`;
};

export const getCloudProvidersViewPath = (
    organizationId: string,
    cloudProviderId: string
): string => {
    return `${AppRoute.CLOUD_PROVIDERS_VIEW.replace(
        PLACEHOLDER_ORGANIZATION_ID,
        organizationId
    ).replace(PLACEHOLDER_CLOUD_PROVIDER_ID, cloudProviderId)}`;
};

export const getCloudProvidersViewGeneralPath = (
    organizationId: string,
    cloudProviderId: string
): string => {
    return `${AppRoute.CLOUD_PROVIDERS_VIEW_GENERAL.replace(
        PLACEHOLDER_ORGANIZATION_ID,
        organizationId
    ).replace(PLACEHOLDER_CLOUD_PROVIDER_ID, cloudProviderId)}`;
};

export const getCloudProvidersViewAdvancedPath = (
    organizationId: string,
    cloudProviderId: string
): string => {
    return `${AppRoute.CLOUD_PROVIDERS_VIEW_ADVANCED.replace(
        PLACEHOLDER_ORGANIZATION_ID,
        organizationId
    ).replace(PLACEHOLDER_CLOUD_PROVIDER_ID, cloudProviderId)}`;
};

export const getCloudProvidersCreatePath = (organizationId: string): string => {
    return `${AppRoute.CLOUD_PROVIDERS_CREATE.replace(
        PLACEHOLDER_ORGANIZATION_ID,
        organizationId
    )}`;
};

export const getCloudProvidersEditPath = (
    organizationId: string,
    cloudProviderId: string
): string => {
    return `${AppRoute.CLOUD_PROVIDERS_EDIT.replace(
        PLACEHOLDER_ORGANIZATION_ID,
        organizationId
    ).replace(PLACEHOLDER_CLOUD_PROVIDER_ID, cloudProviderId)}`;
};

export const getIdentityProvidersPath = (organizationId: string): string => {
    return `${AppRoute.IDENTITY_PROVIDERS.replace(
        PLACEHOLDER_ORGANIZATION_ID,
        organizationId
    )}`;
};

export const getIdentityProvidersListPath = (
    organizationId: string
): string => {
    return `${AppRoute.IDENTITY_PROVIDERS_LIST.replace(
        PLACEHOLDER_ORGANIZATION_ID,
        organizationId
    )}`;
};

export const getIdentityProvidersViewPath = (
    organizationId: string,
    identityProviderId: string
): string => {
    return `${AppRoute.IDENTITY_PROVIDERS_VIEW.replace(
        PLACEHOLDER_ORGANIZATION_ID,
        organizationId
    ).replace(PLACEHOLDER_IDENTITY_PROVIDER_ID, identityProviderId)}`;
};

export const getIdentityProvidersViewGeneralPath = (
    organizationId: string,
    identityProviderId: string
): string => {
    return `${AppRoute.IDENTITY_PROVIDERS_VIEW_GENERAL.replace(
        PLACEHOLDER_ORGANIZATION_ID,
        organizationId
    ).replace(PLACEHOLDER_IDENTITY_PROVIDER_ID, identityProviderId)}`;
};

export const getIdentityProvidersViewAdvancedPath = (
    organizationId: string,
    identityProviderId: string
): string => {
    return `${AppRoute.IDENTITY_PROVIDERS_VIEW_ADVANCED.replace(
        PLACEHOLDER_ORGANIZATION_ID,
        organizationId
    ).replace(PLACEHOLDER_IDENTITY_PROVIDER_ID, identityProviderId)}`;
};

export const getIdentityProvidersCreatePath = (
    organizationId: string,
    linkTo?: string
): string => {
    const path = `${AppRoute.IDENTITY_PROVIDERS_CREATE.replace(
        PLACEHOLDER_ORGANIZATION_ID,
        organizationId
    )}`;

    if (!linkTo) {
        return path;
    }

    return `${path}?linkTo=${linkTo}`;
};

export const getUsersPath = (organizationId: string): string => {
    return `${AppRoute.USERS.replace(
        PLACEHOLDER_ORGANIZATION_ID,
        organizationId
    )}`;
};

export const getUsersListPath = (organizationId: string): string => {
    return `${AppRoute.USERS_LIST.replace(
        PLACEHOLDER_ORGANIZATION_ID,
        organizationId
    )}`;
};

export const getUsersInvitePath = (organizationId: string): string => {
    return `${AppRoute.USERS_INVITE.replace(
        PLACEHOLDER_ORGANIZATION_ID,
        organizationId
    )}`;
};

export const getLoginPath = (): string => {
    return AppRoute.LOGIN;
};

export const getSignupPath = (): string => {
    return AppRoute.SIGNUP;
};

export const getLogoutPath = (): string => {
    return AppRoute.LOGOUT;
};
